// import { useAppSelector } from "../../../../Redux/hooks";
// import AppointmentsList from "./AppointmentsList";
// // import ChatHistoryList from "./ChatHistoryList";
// import ConsentFormsList from "./ConsentFormsList";
// import ParticipantDetails from "../../ParticipantDetails";
// import TeleHealthCalls from "./TeleHealthCalls";

import { useAppSelector } from "../../../Redux/hooks";
// import AppointmentsList from "./Appointments/AppointmentsList";
import ConsentForms from "./ConsentForms/ConsentForms";
import SunshineForms from "./ConsentForms/SunshineForms";
// import MedicationContentWrapper from "./Medication/MedicationContentWrapper";
import ParticipantDetails from "./ParticipantDetails";
// import TeleHealthCalls from "./Telehealth/TeleHealthCalls";

const ContentSelector = ({ showDownloadModal, setShowDownloadModal }: any) => {
  const type = useAppSelector((state) => state.participantTab.menuType);

  switch (type) {
    case "participant_information":
      return (
        <ParticipantDetails
          showDownloadModal={showDownloadModal}
          setShowDownloadModal={setShowDownloadModal}
        />
      );
    // case "medication":
    //   return <MedicationContentWrapper />;
    case "consent":
      return <ConsentForms />;
    case "sunshine_forms":
      return <SunshineForms />;
    // case "appointments":
    //   return <AppointmentsList />;
    // case "telehealth":
    //   return <TeleHealthCalls />;
    default:
      return null;
  }
};

export default ContentSelector;
